import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Info } from 'lucide-react';

export function EventEndedCard() {
  return (
    <Card className="border-border bg-muted/40">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <Info className="h-5 w-5" />
          This event has ended
        </CardTitle>
        <CardDescription>Registration is no longer open for this event.</CardDescription>
      </CardHeader>
    </Card>
  );
}
